module.exports = __webpack_public_path__ + "static/media/logo-prestashop.bb7a88f4.png";